import React, { useEffect, useContext, useState, useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { getQueryStringParams } from '../../utils/utils'

import { getReservation } from '../../services/GetReservation'
import { getCountries } from '../../services/GetCountries'
import { getGroupsDetails } from '../../services/GetGroupsDetails'
import { validateGoogleCaptcha } from '../../services/ValidateGoogleCaptcha'
import { getStationsConfigurations } from '../../services/Stations'
import { getBlockedTaxNumbers } from '../../services/ValidateTaxNumber'
import { verifyReservationWithRA } from '../review-rental-agreement/api'

import { GroupsImagesContext } from '../../domain-repository/GroupsImagesRepository'
import { DomainContext } from '../../domain-repository/DomainRepository'

import withLang from '../../withLang'
import LanguageInputSection from '../../components/SelectLanguage'
import Loading from '../../components/Loading'

function AutoSearchReservationPage(props) {
  const { i18n, t } = useTranslation()

  const { getSetGroupsConfigurations } = useContext(GroupsImagesContext)
  const {
    setReservation,
    setCountries,
    setDriverInfo,
    language,
    setLanguage,
    setKioskCurrentStationId,
    setPickupDate,
    setAppFlowConfigs,
    appVersionId,
    setSessionId,
    setGroupsDetails,
    setBlockedTaxNumbersList,
    setStationsConfigurations,
    setAdditionalDriverInfo,
  } = useContext(DomainContext);

  const [loading, setLoading] = useState(false)
  const [params, setParams] = useState(null)

  useEffect(() => {
    const queryStringValues = getQueryStringParams(
      props.location && props.location.search ? props.location.search : null
    )

    if (!queryStringValues || !queryStringValues.number || !queryStringValues.pickupStation || !queryStringValues.pickupDate) {
      return props.history.push(`/input-reservation-ref-error?resReference=`)
    }

    setKioskCurrentStationId(queryStringValues.pickupStation)
    setPickupDate(queryStringValues.pickupDate)

    setParams(queryStringValues)
  }, [])

  async function getReservationFromReference() {
    const resReference = params.number
    const stationId = params.pickupStation
    const pickupDate = params.pickupDate
    const lang = params.lang

    let formatedResNumberOrRefMatches = resReference.match(/(.*)count$/i)

    setLoading(true)

    const groupConfig = await getSetGroupsConfigurations()

    const blockedTaxNumbersList = await getBlockedTaxNumbers()
    setBlockedTaxNumbersList(blockedTaxNumbersList.blockedTaxNumbers)

    const translations = i18n?.getResourceBundle(i18n.language)

    Promise.all([
      getReservation({ resNumberOrReference: formatedResNumberOrRefMatches && formatedResNumberOrRefMatches.length > 1 ? formatedResNumberOrRefMatches[1] : resReference, stationId, resCheckOutDate: pickupDate, appVersionId, language, autoSearch: true }),
      getCountries(),
      getGroupsDetails(Object.keys(groupConfig)),
      getStationsConfigurations(),
    ])
      .then(([reservation, countries, groups, stationsConfigurationsRes]) => {

        if (!reservation || !countries || !groups || groups.length === 0) {
          props.history.push(`/input-reservation-ref-error?resReference=${resReference}`)
        } else {
          if (!reservation.redirectUrl) {
            setReservation(reservation)
            setDriverInfo(reservation.listReservation)
            setAdditionalDriverInfo(reservation.listReservation)
            setAppFlowConfigs(reservation.appFlowConfigs)
            setSessionId(reservation.sessionId)
          }
          setCountries(countries.map(c => ({ ...c, name: t(`country_${c.countryID}`) })))
          setGroupsDetails(groups.groupsDetails)
          setStationsConfigurations(stationsConfigurationsRes.stationsConfigurations)

          if (reservation.redirectUrl) {
           return props.history.push(reservation.redirectUrl)
          }
          props.history.push('/review-reservation');
        }
      })
      .catch(err => {
        const errorMessage = err?.message || err || null
        props.history.push({ pathname: `/input-reservation-ref-error`, search: `resReference=${resReference}`, state: { errorMessage } })
      });
  }

  function innerChangeLanguage() {
    getReservationFromReference()
  }

  return (
    <div>
      {loading && <Loading active={true} />}
      <LanguageInputSection onChange={innerChangeLanguage} handleLogoClick={() => props.history.push('/start')} />
    </div>
  )
}

export default AutoSearchReservationPage